import * as Yup from 'yup'
import { cmsProductsWidgetItemValidationSchema } from './ProductsItem'

export const productsSchemaValidation = Yup.object().shape({
  content: Yup.object({
    cmsProductsWidgetItems: cmsProductsWidgetItemValidationSchema,
  }),
})
